"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
var CardTheme = /* @__PURE__ */ ((CardTheme2) => {
  CardTheme2["Dark"] = "dark";
  CardTheme2["Light"] = "light";
  return CardTheme2;
})(CardTheme || {});
function getCardClassName({
  theme,
  className,
  elevation,
  clickable,
  draggable
}) {
  return classNames("card", `card--${theme}`, `card--level-${elevation}`, className, {
    "card--clickable": clickable,
    "card--draggable": draggable
  });
}
const Card = observer((_a) => {
  var _b = _a, { theme = "light" /* Light */, className, elevation = 0 } = _b, props = __objRest(_b, ["theme", "className", "elevation"]);
  return /* @__PURE__ */ React.createElement("div", __spreadValues({ className: getCardClassName({ theme, className, elevation }) }, props));
});
const LinkCard = observer(
  (_c) => {
    var _d = _c, { theme = "light" /* Light */, className, elevation = 0, target, rel } = _d, props = __objRest(_d, ["theme", "className", "elevation", "target", "rel"]);
    const defaultRel = target === "_blank" ? "noopener noreferrer" : void 0;
    return /* @__PURE__ */ React.createElement(
      "a",
      __spreadValues({
        className: getCardClassName({ theme, className, elevation, clickable: true }),
        rel: rel || defaultRel,
        target
      }, props)
    );
  }
);
const ButtonCard = observer(
  (_e) => {
    var _f = _e, { theme = "light" /* Light */, className, isDraggable, elevation = 0 } = _f, props = __objRest(_f, ["theme", "className", "isDraggable", "elevation"]);
    return /* @__PURE__ */ React.createElement(
      "button",
      __spreadValues({
        className: getCardClassName({ theme, className, clickable: true, draggable: !!isDraggable, elevation })
      }, props)
    );
  }
);
export { Card, LinkCard, ButtonCard, CardTheme };
